import { render, staticRenderFns } from "./impressum.vue?vue&type=template&id=19dc2cfa&scoped=true"
import script from "./impressum.vue?vue&type=script&lang=js"
export * from "./impressum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc2cfa",
  null
  
)

export default component.exports